import React, { useEffect, useState, useMemo, useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import '@ag-grid-community/styles/ag-grid.css';
import '@ag-grid-community/styles/ag-theme-quartz.css';
import {
  Header,
} from '@backstage/core-components';
import 'ag-grid-enterprise';
import Loader from '../loader/Loader';
import { discoveryApiRef, useApi, fetchApiRef, identityApiRef} from '@backstage/core-plugin-api';
import '../NoteCustomstyle.css';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

const NetworkInterfaces = () => {
  const gridRef = useRef<any>(null);
  const containerStyle = useMemo(() => ({ width: "100%", height: "100vh" }), []);
  const gridStyle = useMemo(() => ({ height: 'calc(-200px + 80vh)', width: "100%", marginTop: '50px' }), []);
  const [rowData, setRowdata] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [tenantName, settenantName] = useState<string>(''); // dropdown state
  const [org, setOrg] = useState('');
  const [role, setRole] = useState('');
  const discoveryApi = useApi(discoveryApiRef);
  const fetchApi = useApi(fetchApiRef);
  const [tenantsFromDb, setTenantsFromDb] = useState<any[]>([]);
  const identityApi = useApi(identityApiRef)

  const fetchTenantsFromDb = async () => {
    try {
      const baseUrl = await discoveryApi.getBaseUrl('user');
      const response = await fetchApi.fetch(`${baseUrl}/tenants`);
      if (!response.ok) throw new Error("Failed to fetch tenants");
      return await response.json();
    } catch (e) {
      console.error("Error fetching tenants:", e);
      return [];
    }
  };

  const fetchTenant = async () => {
    try {
      const details = await identityApi.getBackstageIdentity();
      const id = details.ownershipEntityRefs.find(ref =>
        ref.startsWith('tenantId:')
      )?.split(':')[1] || null;

      console.log("ID ---------", id)
      return id
    } catch (err) {
      console.error('Failed to get tenantId:', err);
    }
  }; 

  useEffect(() => {
    const fetchData = async () => {
      try {
        const tenants = await fetchTenantsFromDb();
        const id = await fetchTenant()
        console.log(`orgName:${id}`)
        const tenantOrgName = localStorage.getItem(`orgName:${id}`);
        console.log('tenantOrgName------',tenantOrgName)
        if (tenantOrgName) setOrg(tenantOrgName);
        setTenantsFromDb(tenants);
        const baseurl = await discoveryApi.getBaseUrl('user');
        let data: any[] = [];
        try {
          const fetchresponse = await fetchApi.fetch(`${baseurl}/unattached-interfaces`, { method: 'POST' });
          if (!fetchresponse.ok) {
            const errorText = await fetchresponse.text();
            throw new Error(`API error: ${fetchresponse.status} - ${errorText}`);
          }
          const response = await fetchresponse.json();
          setRole(response.role);
          data = response.data || [];
          console.log('Fetched data:', data);
        } catch (error) {
          console.error('Fetch or JSON parse error:', error);
        }
        setRowdata(data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    fetchData();
    let orgName = localStorage.getItem('orgName')
    if (orgName) {
      setOrg(orgName)
    }
  }, [])

  const publicipFormatter = (params: any) => {
    if (!params.node.group) {
      if (params.value !== "NA") {
        return "Yes";
      }
      return "No"
    }
  }

  const statusFormatter = (params: any) => {
    if (!params.node.group) {
      if (params.value === "available") {
        return "Yes";
      }
      return "No";
    }
  }

  const columnDefs = useMemo(() => {
    const baseCols = [
    { headerName: "Tenant Name", field: "tenantName", headerTooltip: "Tenant Name", rowGroup: true },
    { headerName: "Account Id", field: "accountId", headerTooltip: "Account Id", rowGroup: true },
    { headerName: "Region", field: "region", headerTooltip: "Region" },
    { headerName: "Network Interface Id", field: "networkInterfaceId", headerTooltip: "Network Interface Id" },
    { headerName: "Unattached", field: "status", headerTooltip: "Unattached", valueFormatter: statusFormatter },
    { headerName: "Public Ip", field: "publicIp", headerTooltip: "Public Ip", valueFormatter: publicipFormatter },
    { headerName: "Cost in $ (per IP per month)", field: "cost", headerTooltip: "Cost", aggFunc: 'sum', valueFormatter: params => {
      const value = parseFloat(params.value);
      return !isNaN(value) ? value.toFixed(2) : undefined;
    }},
  ];
  
  return baseCols.map(col =>
    col.field === "tenantName"
      ? { ...col, hide: role != "SuperAdmin", rowGroup: role != "SuperAdmin" ? false : col.rowGroup }
      : col
  );
}, [role]);

  const defaultColDef = useMemo(() => ({
    flex: 1, filter: true, sortable: true, resizable: true, enableRowGroup: true,
    tooltipShowDelay: 0, tooltipInteraction: true, columnMenu: "new"
  }), []);

  const autoGroupColumnDef = { minWidth: 250, cellRendererParams: {
    footerValueGetter: (params: any) => params.node.level === -1 ? "Potential Cost Savings" : "Sub Total"
  }};

  const sideBar = { toolPanels: [{ id: 'columns', labelDefault: 'Columns', labelKey: 'columns', iconKey: 'columns', toolPanel: 'agColumnsToolPanel' }], defaultToolPanel: '' };
  const gridOptions = { suppressContextMenu: true };

  // Filter data by tenant dropdown
  const filteredData = tenantName ? rowData.filter(r => String(r.tenantName) === String(tenantName)) : rowData;
  const tenants = [...new Set(rowData.map(r => r.tenantName))];

  return (
    <div style={containerStyle}>
      <Header title="Network Interfaces" subtitle={org} />

      {/* Tenant dropdown for SuperAdmin only */}
      {role === "SuperAdmin" && (
        <div style={{ display: "flex", justifyContent: "flex-end", margin: "10px 0" }}>
          <FormControl variant="outlined" size="small" style={{ minWidth: 200 }}>
            <InputLabel></InputLabel>
            <Select
              value={tenantName}
              onChange={(e) => settenantName(e.target.value)}
              displayEmpty
              MenuProps={{
                PaperProps: {
                  sx: {
                    // force vertical stacking
                    '& .MuiList-root': {
                      display: 'flex !important',
                      flexDirection: 'column !important',
                    },
                    // force left-aligned text inside items
                    '& .MuiMenuItem-root': {
                      justifyContent: 'flex-start',
                      pl: 2,
                    },
                  },
                },
              }}
            >
              <MenuItem value="">All Tenants</MenuItem>
              {tenantsFromDb.map((tenant) => (
                <MenuItem key={tenant.id} value={tenant.name}>
                  {tenant.name}
                </MenuItem>
                ))}
            </Select>
          </FormControl>
        </div>
      )}

      {loading ? <Loader /> : (
        <div>
          <div className="ag-theme-quartz resourcecost" style={{ ...gridStyle, marginTop: 10 }}>
            <AgGridReact
              ref={gridRef}
              rowData={filteredData}
              columnDefs={columnDefs}
              autoGroupColumnDef={autoGroupColumnDef}
              rowGroupPanelShow="always"
              sideBar={sideBar}
              defaultColDef={defaultColDef}
              groupIncludeFooter
              groupIncludeTotalFooter
              groupDefaultExpanded={-1}
              suppressAggFuncInHeader
              gridOptions={gridOptions}
            />
          </div>
          <div className="recommended-action-container">
            <div className="scroll-container">
              <strong>Recommended Action</strong>
              <ul>
                <li>
                  <strong>Streamline Public IPs for Network Interfaces</strong>
                  <p>Managing public IPs for network interfaces helps optimize costs by ensuring that you are only paying for necessary resources. Here’s how to approach it:</p>
                  <ul>
                    <li>Identify Public IPs: Check for public IPs associated with network interfaces in the EC2 Dashboard.</li>
                    <li>Evaluate Usage: Determine if the network interfaces are in use or unattached.</li>
                    <li>Manage Public IPs: For unattached network interfaces with unnecessary public IPs, disassociate or delete these IPs.</li>
                  </ul>
                  <p>Considerations:</p>
                  <ul>
                    <li>Removing public IPs from attached network interfaces can disrupt connectivity, cause service interruptions, increase management complexity, and affect security.</li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
          <div className="note-container">
            <p>
              <strong>Note*</strong><span className="note-text">: To estimate potential cost savings for network interfaces, the cost of public IP addresses was calculated based on $0.005 per hour. The total monthly cost for each unattached network interface with a public IP was compared, while interfaces without public IPs do not contribute to potential savings.</span>
            </p>
          </div>
        </div>
      )}
    </div>
  )
}

export default NetworkInterfaces;
